import React from 'react'
import { C } from './ui'

const NAV_ITEMS = [
  { id: 'home',    label: 'Home',      icon: HomeIcon  },
  { id: 'board',   label: 'Rankings'  , icon: StarIcon  },
  { id: 'matches', label: 'Games',     icon: MatchesIcon },
  { id: 'sigma',   label: 'Results',   icon: SigmaIcon },
  { id: 'plays',   label: 'My Plays',  icon: PlaysIcon },
  { id: 'tracker', label: 'Tracker',   icon: ChartIcon },
  { id: 'contact', label: 'Contact',   icon: ContactIcon },
  { id: 'alerts',  label: 'Alerts',    icon: BellIcon  },
]

export function BottomNav({ active, onSelect }) {
  return (
    <nav style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 200,
      background: C.bk2, borderTop: `1px solid ${C.border}`,
      display: 'flex',
      paddingBottom: 'env(safe-area-inset-bottom, 0)',
    }}>
      {NAV_ITEMS.map(item => {
        const isOn = active === item.id
        return (
          <button key={item.id} onClick={() => onSelect(item.id)} style={{
            flex: 1, display: 'flex', flexDirection: 'column',
            alignItems: 'center', gap: 3, padding: '10px 4px 8px',
            border: 'none', background: 'none', cursor: 'pointer',
            fontFamily: "'Rajdhani', sans-serif", fontWeight: 700,
            fontSize: 9, letterSpacing: '0.06em', textTransform: 'uppercase',
            color: isOn ? C.blue : C.dim,
            transition: 'color 0.2s',
            position: 'relative',
          }}>
            {isOn && (
              <div style={{
                position: 'absolute', top: 0, left: '50%',
                transform: 'translateX(-50%)',
                width: 28, height: 2,
                background: C.blue,
                boxShadow: `0 0 10px ${C.blue}`,
                borderRadius: '0 0 4px 4px',
              }} />
            )}
            <item.icon color={isOn ? C.blue : C.dim} />
            {item.label}
          </button>
        )
      })}
    </nav>
  )
}

function HomeIcon({ color }) {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
}
function StarIcon({ color }) {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
}
function SigmaIcon({ color }) {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"><path d="M18 6H6l7 6-7 6h12"/></svg>
}
function PlaysIcon({ color }) {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
}
function ChartIcon({ color }) {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
}
function MatchesIcon({ color }) {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
}
function ContactIcon({ color }) {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M5 5c3.5 3 3.5 11 0 14M19 5c-3.5 3-3.5 11 0 14"/></svg>
}
function BellIcon({ color }) {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
}
